<div class="loader-backdrop" *ngIf="loader.loading$ | async">
  <div class="loader-box">
    <img src="assets/images/truck.gif" alt="Loading..." />
  </div>
</div>
